<template>
  <div class="feedback">
    <!-- <m-loading :loading="homeLoading" /> -->
    <img
      class="feedbackList_img"
      src="@/assets/images/mine/yijianfankui_bg.png"
      alt=""
    />
    <div class="box_panel">
      <div class="top_tip">
        <div class="p1">Hi ~ 有什么可以帮您？</div>
        <div class="p2">请选择您的反馈类型</div>
      </div>
      <div class="top_type">
        <div class="item" @click="onLoadActivity">
          <div class="img1">
            <img class="" src="@/assets/images/mine/huodongzixun.png" alt="" />
          </div>
          <div class="p1">活动咨询</div>
        </div>
        <div class="item" @click="getFeedback(2)">
          <div class="img1">
            <img class="" src="@/assets/images/mine/pingtaizixun.png" alt="" />
          </div>
          <div class="p1">平台咨询</div>
        </div>
        <div class="item" @click="getFeedback(3)">
          <div class="img1">
            <img class="" src="@/assets/images/mine/tousujianyi.png" alt="" />
          </div>
          <div class="p1">投诉建议</div>
        </div>
      </div>
      <div class="activity_box" v-if="swActivity.length > 0">
        <div class="activity_title">选择您要咨询的活动</div>
        <div class="activity_list_box">
          <div
            class="activity_list"
            @click="getFeedback(1, item)"
            v-for="(item, index) in swActivity"
            :key="index"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>

    <!-- <van-field v-model="suggest" rows="4" :autosize="{ 'maxHeight': 300,'minHeight':400}" type="textarea"
			maxlength="300" placeholder="请输入建议内容" show-word-limit />
		<div class="save">
			<van-button size="large" :loading="subLoading" color="linear-gradient(to right, #5DD682, #5AFF8E)"
				@click="save">提交</van-button>
		</div> -->
  </div>
</template>

<script>
import { getPageActivity } from "@/utils/api/home";
export default {
  data() {
    return {
      suggest: "",
      subLoading: false,
      swActivity: [],
      homeLoading: false
    };
  },
  mounted() {
    // this.onLoadActivity()
  },
  methods: {
    getFeedback(type, data) {
      this.$router.push({
        path: "/mine/Feedback",
        query: {
          type: type,
          data: JSON.stringify(data)
        }
      });
    },
    // 活动列表数据
    onLoadActivity() {
      this.swActivity = [];
      this.$toast.loading({
        duration: 0 // 持续展示 toast
      });
      getPageActivity({
        pageNo: 1,
        pageSize: 100
      }).then((res) => {
        if (res.success) {
          this.swActivity = res.data.records;
        }
        this.$toast.clear();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.feedback {
  width: 375px;
  position: absolute;
  min-height: 100vh;
  background-color: #f9f9fa;
  padding: 10px 15px;

  .feedbackList_img {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0;
    // height: 339px;
    width: 10rem;
    margin: 0 auto;
  }

  .box_panel {
    position: relative;
    text-align: left;

    .activity_box {
      margin-top: 15px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;

      .activity_title {
        font-weight: bold;
        font-size: 16px;
        color: #222222;
        border-bottom: 1px solid #eeeeee;
        padding: 10px 17px;
      }
      .activity_list_box {
        padding: 0 15px;
        max-height: 300px;
        overflow-y: auto;
        .activity_list {
          border-bottom: 1px solid #eeeeee;
          padding: 13px 0;
          font-weight: 400;
          font-size: 14px;
          color: #222222;
          &:last-child {
            border: none;
          }
        }
      }
    }

    .top_type {
      display: flex;
      justify-content: space-between;
      padding-top: 7px;

      .item {
        background-color: #fff;
        width: 105px;
        border-radius: 8px 8px 8px 8px;
        text-align: center;
        padding: 17px 0 15px 0;

        img {
          width: 35px;
          height: 35px;
        }

        .p1 {
          font-weight: 500;
          font-size: 14px;
          color: #666666;
          padding-top: 5px;
        }
      }
    }

    .top_tip {
      padding: 15px;

      .p1 {
        font-weight: bold;
        font-size: 18px;
        color: #222222;
      }

      .p2 {
        font-weight: 400;
        font-size: 12px;
        color: #666666;
        padding-top: 8px;
      }
    }
  }

  .van-cell {
    border: 1px solid #e4e4e4;
    border-radius: 5px;
  }

  .save {
    width: 290px;
    margin: 0 auto;
    margin-top: 30px;

    .van-button {
      border-radius: 16px;
      width: 254px;
      height: 32px;
    }
  }
}
</style>
